import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'

import axios from 'axios'
Vue.prototype.$http = axios
// call axios using
// this.$http.get('https://us-central1-golf-ee7a0.cloudfunctions.net/sendText?text=d9')

import './main.css'
import './global.css'

Vue.config.productionTip = false

new Vue({

  store,
  created: function () {
      /*
      let x = 0
      x = this.$store.dispatch('getMsecSince','') // timing mark
      x.then ( function () {
        console.log("elapsedMsec0",x) 
      })
      */

      // `this` points to the vm instance
      console.log('main.js new Vue')
      this.$store.dispatch('loadFirebaseData','') // expect messages

      

      return
      /*
      this.$store.dispatch('setLoading','APB') // expect loadings, one per character code
      this.$store.dispatch('loadFirebaseSolarPermitData','called from main.js')
      this.$store.dispatch('loadFirebaseAssessorData','called from main.js')
      this.$store.dispatch('loadFirebaseBills','B')

      // the loadings below all specify their own loading states
      this.$store.dispatch('loadUserParams','S')    // S loading state is specified by this call
      */
  },


  vuetify,
  render: h => h(App)
}).$mount('#app')
